import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import { StyledEngineProvider } from '@mui/material/styles';

import { SubmissionsModalDeleteIcon } from '../../svgs';
import { useMediaTableContext } from '../../../hooks/contexts';
import { useVpSnackbar } from '../../hooks';
import { useDeleteSubmission, useDeleteResponse } from '../../../hooks/react-query';
import { VpButton, VpIcon } from '../../components';
import { VpDialogTitle } from '../../components/VpDialogTitle';
import { VpDialogContent } from '../../components';

import styles from './VpDeleteModal.module.less';

const entityTypes = {
  SUBMISSION: 'Submission',
  RESPONSE: 'Response'
};

const VpDeleteModal = () => {
  const {
    selectedEntity,
    setSelectedEntity,
    setSelectedSubmissionId,
    onMediaCheck,
    onSubmissionCheck
  } = useMediaTableContext();
  const { mutate: deleteSubmissionMutation, isSuccess } = useDeleteSubmission();
  const { mutate: deleteResponseMutation, isSuccess: responseIsSuccess } = useDeleteResponse();
  const { addSnackbarSuccess } = useVpSnackbar();

  const isVisible = !!selectedEntity;
  const [entityType, setEntityType] = useState(null);

  useEffect(() => {
    if (selectedEntity || !entityType) {
      setEntityType(
        selectedEntity?.campaignSubmissionId ? entityTypes.SUBMISSION : entityTypes.RESPONSE
      );
    }
  }, [selectedEntity]);

  const runAppropriateMutation = (entity, entityType) => {
    if (entityType === entityTypes.SUBMISSION) {
      onSubmissionCheck(entity?.campaignSubmissionId);
      return deleteSubmissionMutation(entity?.campaignSubmissionId);
    }
    if (entityType === entityTypes.RESPONSE) {
      onMediaCheck(entity);
      return deleteResponseMutation(entity?.campaignResponseId);
    }
    return null;
  };

  useEffect(() => {
    if (isSuccess || responseIsSuccess) {
      addSnackbarSuccess({
        message: `${entityType} was deleted.`
      });
      setSelectedSubmissionId(null);
    }
  }, [isSuccess, responseIsSuccess]);

  return (
    <StyledEngineProvider injectFirst>
      <Dialog onClose={() => setSelectedEntity(null)} open={isVisible}>
        <VpDialogTitle
          leftContent={`Delete ${entityType}`}
          onClose={() => setSelectedEntity(null)}
          className={styles.vpModalHeader}
        />
        <VpDialogContent className={styles.vpModalContainer}>
          <SubmissionsModalDeleteIcon className={styles.vpModalIcon} />
          <Typography className={styles.vpModalWarning}>
            Are you sure you want to delete? This action cannot be undone.
          </Typography>
          <DialogActions className={styles.vpModalActions}>
            <VpButton color="neutral" variant="contained" onClick={() => setSelectedEntity(null)}>
              Cancel
            </VpButton>
            <VpButton
              variant="contained"
              className={styles.vpModalDeleteButton}
              onClick={() => {
                runAppropriateMutation(selectedEntity, entityType);
                setSelectedEntity(null);
              }}
              startIcon={<VpIcon icon="Trash2" />}
            >
              Delete {entityType}
            </VpButton>
          </DialogActions>
        </VpDialogContent>
      </Dialog>
    </StyledEngineProvider>
  );
};

export default VpDeleteModal;
VpDeleteModal.displayName = 'VpDeleteModal';



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpDeleteModal.jsx